
    <p-accordion #primeAccordionPanel multiple="true">
      <ng-content></ng-content>
    </p-accordion>
  